<template>
  <div class="list-actions">
    <check-permission
      v-for="action in availableActions"
      :key="`action_${action.id || action.event}`"
      :permissions="actionPermissions(action)"
    >
      <w-button
        class="btn-light mr-2 mb-2"
        :class="action.class"
        :icon="action.icon"
        :text="action.tooltipText || action.name"
        :style="{ color: actionColor(action) }"
        @click="$emit(action.event, { action })"
      />
    </check-permission>

    <slot name="extraActions" />
  </div>
</template>

<script>
import { actionsMixin } from '@/mixins/actions';
import { flat } from '@/utils/flat';

// @vuese
// Akcje listy dokumentów
// @group Components
export default {
  name: 'Actions',
  mixins: [actionsMixin],
  props: {
    // Identyfikatory wybranych encji
    entityIds: { type: Array, required: false },
    // Typ encji
    entityType: { type: String, required: false }
  },
  computed: {
    availableActions() {
      if (this.entityIds.length === 1) {
        return this.actions;
      }
      return this.actions.filter(action => !action.singleOnly);
    }
  },
  methods: {
    // @vuese
    // Uprawnienia do akcji
    actionPermissions(action) {
      let permissions = action.permissions ? action.permissions : this.getPermissions(action.permissionTypes);
      if (!this.entityIds?.length || !this.entityType) {
        return permissions;
      }

      if (!Array.isArray(permissions)) {
        permissions = [permissions];
      }

      permissions = flat(
        permissions.map(permission => this.entityIds.map(entityId => `${permission}:${this.entityType}:${entityId}`))
      );

      if (action.id) {
        permissions.push('BUTTON.USE:button:' + action.id);
      }

      return permissions;
    }
  }
};
</script>

<style>
.list-actions {
  position: sticky;
  top: 0;
  background: white;
  padding-top: 0.5rem;
}
</style>
